import { render, staticRenderFns } from "./Resetpopup.vue?vue&type=template&id=476bcb94&"
import script from "./Resetpopup.vue?vue&type=script&lang=js&"
export * from "./Resetpopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports